<template>
  <vs-popup class="add-new-carrier"
            id="popup"
            title="UPDATE INDUSTRIAL SECTOR"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form id="update-industrial-sector-popup" @submit.prevent="handleSubmit(onClickUpdateIndustrialSector)" autocomplete="off">

        <div class="mb-3 vx-row">
          <div class="w-full vx-col md:w-full md:mb-0">
            <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
              <small class="label">Name</small>
              <vs-input v-model="form.name"  name="name" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row ml-1">
          <span class="label">Sub sectors</span>
        </div>
        <div v-for="(sector,index) in form.sub_sectors">
          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-5/6 md:mb-0">
              <ValidationProvider :vid="`sub_sector_name${index}`" :name="`sub_sector_name${index}`" rules="required" v-slot="{ errors }">
                <vs-input v-model="form.sub_sectors[index].name"  :name="`sub_sector_name${index}`" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="w-full vx-col md:w-1/6 md:mb-0 mt-1 ">
              <div class="vx-row justify-start">
              <vs-button v-if="form.sub_sectors.length > 1" @click = "removeSubSection(index)" class="ml-3"
                         size="small" color="danger" type="border" icon-pack="feather" icon="icon-trash-2"></vs-button>
              </div>
            </div>
          </div>
        </div>
        <vs-button @click="addNewSubSector" class="mt-2 ml-auto" size="small">Add new Sub Sector</vs-button>
        <div class="flex flex-wrap items-center justify-end mt-8">
          <vs-button button="submit" class="mt-2 ml-auto">Save Changes</vs-button>
          <vs-button @click="clearForm" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
        </div>
      </form>
    </ValidationObserver>

  </vs-popup>

</template>

<script>
import {RepositoryFactory} from '@/repository/RepositoryFactory'
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

const IndustrialSectorsRepository = RepositoryFactory.get('industrial_sector')

export default {
  name: "UpdateIndustrialSectorPopUp",
  data(){
    return {
      open: false,
      id: '',
      form: {
        parent_id: null,
        name: '',
        sub_sectors:[]
      },
    }
  },
  mixins: [SuccessMessage, ErrorMessages],
  methods: {
    async openPopup(id) {
      this.id = id;
      // this.$refs.form.reset();
      this.open = true;
      await this.fetchIndustrialSector()
    },
    async onClickUpdateIndustrialSector(){
      const vue = this
      this.$vs.loading()
      await IndustrialSectorsRepository.updateIndustrialSector(this.id, this.form)
      this.$vs.loading.close()
      vue.$parent.refreshData()
      this.open = false
    },
    async fetchIndustrialSector() {
      await this.$vs.loading()
      const {data} = await IndustrialSectorsRepository.getIndustrialSector(this.id)
      this.form.parent_id = data.data.parent_id
      this.form.name = data.data.name
      this.form.sub_sectors = data.data.sub_sectors.map(sector => {
        return {
          id:sector.id,
          name:sector.name
        }
      })
      this.$vs.loading.close()
    },
    // async updateSubSector(index) {
    //   await this.$vs.loading()
    //   try {
    //     if(this.form.sub_sectors[index].id) {
    //       const updatePayload = {
    //         name: this.form.sub_sectors[index].name,
    //         parent_id: this.form.sub_sectors[index].parent_id,
    //       }
    //       await IndustrialSectorsRepository.updateIndustrialSector(this.form.sub_sectors[index].id, updatePayload)
    //     }else {
    //       const createPayload = {
    //         parent_id:this.id,
    //         sub_sectors:[
    //           {
    //             name: this.form.sub_sectors[index].name
    //           }
    //         ]
    //       }
    //       await IndustrialSectorsRepository.createIndustrialSector(createPayload)
    //     }
    //     this.showSuccessMessage('Successfully updated the sector')
    //   }catch (error){
    //     this.$vs.loading.close()
    //     this.convertAndNotifyError(error)
    //   }
    //   this.$vs.loading.close()
    // },
    removeSubSection(index){
      this.form.sub_sectors.splice(index,1)
    },
    clearForm(){
      this.form = {
        parent_id: null,
        name: '',
        sub_sectors:[]
      }
    },
    addNewSubSector(){
      this.form.sub_sectors.push({
        name:''
      })
    },
  },
}
</script>

<style scoped>

</style>
